import React from 'react';
import { Typography } from '@mui/material';
import { getLocalDate } from '@surfline/web-common';
import { format } from 'date-fns';
import type { ScaleTime } from 'd3-scale';

import type { LiveWindPoint } from 'types/liveWind';

import { oneMinute, oneSecond } from 'utils/time';
import styles from './LiveWindDataVisualizer.module.scss';

interface Props {
  xPercentage: number;
  xScale: ScaleTime<number, number>;
  data: Array<LiveWindPoint>;
  graph: 'LINE' | 'BAR';
}

const TimeLine: React.FC<Props> = ({ xPercentage, data, xScale, graph }) => {
  const hoverPoint = data[Math.floor(data.length * xPercentage)];
  if (!hoverPoint) {
    return null;
  }

  const currentUnixTimestamp = Math.floor(+new Date() / 1000);

  const timeDifference = currentUnixTimestamp - hoverPoint.timestamp;

  /**
   * calculate range 10 min behind the current time
   */
  const isNow = timeDifference >= 0 && timeDifference < (oneMinute * 10) / oneSecond;

  const text = isNow
    ? 'Now'
    : format(getLocalDate(hoverPoint.timestamp, hoverPoint.utcOffset), 'h:mmaaa');

  return (
    <div
      className={styles.graphTimeLine}
      // use -0.25px offset to center TimeLine position (0.5px width)
      // use 1px (half of bar width) - 0.25px offset to calculate TimeLine position on bar graph
      style={{
        left: `calc(${xScale(hoverPoint.timestamp)}px + ${graph === 'LINE' ? '-0.25px' : '.75px'})`,
      }}
    >
      <Typography
        variant="callout1"
        className={styles.graphTimeLineText}
        sx={(theme) => ({ color: theme.palette.text.brandSecondary })}
      >
        {text}
      </Typography>
    </div>
  );
};

export default TimeLine;
